export default "__VITE_ASSET__df4646ff__"